import React from 'react';
import './DivyFeatureVisual.css';

const DivyFeatureVisual = () => {
  return (
    <div className="dfv-bg">
      <div className="dfv-orders-panel">
        <div className="dfv-orders-header">
          <span className="dfv-orders-title">Orders: <b>All locations</b></span>
        </div>
        <div className="dfv-orders-tabs">
          <span className="dfv-tab dfv-tab-active">All</span>
          <span className="dfv-tab">Unfulfilled</span>
          <span className="dfv-tab">Unpaid</span>
        </div>
        <div className="dfv-orders-table">
          <div className="dfv-table-header">
            <span className="dfv-checkbox" />
            <span className="dfv-col-order">Order</span>
            <span className="dfv-col-date">Date <span className="dfv-sort" /></span>
          </div>
          <div className="dfv-table-row dfv-table-row-1" />
          <div className="dfv-table-row dfv-table-row-2" />
          <div className="dfv-table-row dfv-table-row-3" />
          <div className="dfv-table-row dfv-table-row-4" />
          <div className="dfv-table-row dfv-table-row-5" />
          <div className="dfv-table-row dfv-table-row-6" />
          <div className="dfv-table-row dfv-table-row-7" />
          <div className="dfv-table-row dfv-table-row-8" />
          <div className="dfv-table-row dfv-table-row-9" />
          <div className="dfv-table-row dfv-table-row-10" />
          <div className="dfv-table-row dfv-table-row-11" />
          <div className="dfv-table-row dfv-table-row-12" />
          <div className="dfv-table-row dfv-table-row-13" />
          <div className="dfv-table-row dfv-table-row-14" />
        </div>
        <div className="dfv-dropdown">
          <div className="dfv-dropdown-item">#1024-2</div>
          <div className="dfv-dropdown-item">#1024-1</div>
          <div className="dfv-dropdown-item">#1024</div>
          <div className="dfv-dropdown-item">#1023-1</div>
          <div className="dfv-dropdown-item">#1023</div>
        </div>
      </div>
    </div>
  );
};

export default DivyFeatureVisual; 